// Values double as the API sort keys (getSortBy in the Koa API's lib/availability.js).
// floor, class, zoning and parking are existing sort keys that already sort on the displayed value.
export enum AvailabilityCustomFieldsEnum {
  // availability
  max_contiguous_space = 'max_contiguous_space',
  floor = 'floor',
  use_types = 'use_types',
  primary_use = 'availability_primary_use',
  // building
  building_class = 'class',
  rentable_building_size = 'rentable_building_size',
  column_spacing = 'column_spacing',
  // parking & loading
  car_parks = 'parking',
  parking_ratio = 'parking_ratio',
  trailer_spots = 'trailer_spots',
  // site
  zoning = 'zoning',
  county = 'county',
}
